import React, { FC, useState, useEffect } from "react";
import Layout from "./components/Layout";
import * as utils from "./common/utils";
import "./styles/main.css";
import { DefaultRoute, AuthRoute } from "./routes";
import CONSTS from "./common/constants";
import { AuthProvider } from "react-oidc-context";
import AsyncCallHandler from "../src/common/AsyncCallHandler";
import { custom } from "devextreme/ui/dialog";
import {
  setLocal as set,
  getLocal as get,
  removeLocal as remove,
} from "./common/utils";
import { authConfig } from "./oidcauthentication/authConfig";
import Login from "./oidcauthentication/Login";

// interface MassCommRec {
//   id: string;
//   subject: string;
//   schedularEndDatetime: string | number | Date;
// }

const App: FC = () => {
  // const timeConverter = (val: string) => {
  //   return val.split(".")[0];
  // };

  //Removed SSO
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     let url = "Home/fetchMassCommunication",
  //       method = "get";
  //     AsyncCallHandler(url, method).then((res) => {
  //       if (res && res.data.length > 0) {
  //         if (res.data) {
  //           res.data.map((massCommRec: MassCommRec) => {
  //             if (!get("IsAcknowledged_" + massCommRec.id))
  //               set("IsAcknowledged_" + massCommRec.id, false);
  //             if (!get("IsNotified_" + massCommRec.id))
  //               set("IsNotified_" + massCommRec.id, false);
  //             if (get("IsNotified_" + massCommRec.id) !== "true") {
  //               if (get("IsAcknowledged_" + massCommRec.id) !== "true") {
  //                 let myDialog = custom({
  //                   title: "Notification",
  //                   messageHtml: massCommRec.subject,
  //                   buttons: [
  //                     {
  //                       text: "OK",
  //                       onClick: (e) => {
  //                         return { buttonText: e.component.option("text") };
  //                       },
  //                     },
  //                   ],
  //                 });
  //                 set("IsNotified_" + massCommRec.id, true);

  //                 myDialog.show().then((res: any) => {
  //                   if (res.buttonText === "OK") {
  //                     set("IsAcknowledged_" + massCommRec.id, true);
  //                   }
  //                 });
  //               }
  //             } else if (get("IsNotified_" + massCommRec.id) === "true") {
  //               if (get("IsAcknowledged_" + massCommRec.id) !== "true") {
  //                 let myDialog = custom({
  //                   title: "Notification",
  //                   messageHtml: massCommRec.subject,
  //                   buttons: [
  //                     {
  //                       text: "OK",
  //                       onClick: (e) => {
  //                         return { buttonText: e.component.option("text") };
  //                       },
  //                     },
  //                   ],
  //                 });
  //                 // set("IsNotified_" + massCommRec.id, true);

  //                 myDialog.show().then((res: any) => {
  //                   if (res.buttonText === "OK") {
  //                     set("IsAcknowledged_" + massCommRec.id, true);
  //                   }
  //                 });
  //               }
  //             }
  //             if (massCommRec.schedularEndDatetime) {
  //               if (
  //                 new Date(
  //                   timeConverter(new Date().toISOString())
  //                 ).getMinutes() -
  //                   new Date(massCommRec.schedularEndDatetime).getMinutes() >=
  //                   0 &&
  //                 new Date(timeConverter(new Date().toISOString())).getHours() -
  //                   new Date(massCommRec.schedularEndDatetime).getHours() >=
  //                   0 &&
  //                 new Date(timeConverter(new Date().toISOString())).getDate() -
  //                   new Date(massCommRec.schedularEndDatetime).getDate() >=
  //                   0
  //               ) {
  //                 if (get("IsAcknowledged_" + massCommRec.id)) {
  //                   remove("IsAcknowledged_" + massCommRec.id);
  //                 }
  //                 if (get("IsNotified_" + massCommRec.id)) {
  //                   remove("IsNotified_" + massCommRec.id);
  //                 }

  //                 let massCommData = {
  //                   id: massCommRec.id,
  //                   isSent: true,
  //                 };
  //                 let url = "Home/saveMassCommunication",
  //                   method = "post",
  //                   data = massCommData;
  //                 AsyncCallHandler(url, method, data).then((res) => {
  //                   if (res) {
  //                   }
  //                 });
  //               }
  //             }
  //           });
  //         }
  //       } else {
  //         for (var key in localStorage) {
  //           if (
  //             key.search("IsAcknowledged_") === 0 ||
  //             key.search("IsNotified_") === 0
  //           )
  //             remove(key);
  //         }
  //       }
  //     });
  //   }, 1000 * 60 * 60);

  //   return () => clearInterval(interval);
  // }, []);

  // let userInfo = utils.isUserSessExist();

  // if (!utils.getLocal(CONSTS.REDIRECT_URI)) {
  //   utils.setLocal(CONSTS.REDIRECT_URI, window.location.pathname);
  // }
  // if (userInfo) {
  //   utils.set("hid", userInfo.sub);
  //   utils.set("mailid", userInfo.email);
  //   utils.set("username", `${userInfo.family_name}, ${userInfo.given_name}`);
  //   return (
  //     <Layout isValid="true">
  //       <AuthProvider {...authConfig}>
  //         <DefaultRoute />
  //       </AuthProvider>
  //     </Layout>
  //   );
  // } else {
  //   return (
  //     <Layout isValid="false">
  //       <AuthRoute />
  //     </Layout>
  //   );
  // }

  return (
    <AuthProvider {...authConfig}>
      <Login />
    </AuthProvider>
  );
};

export default App;
